import deserializeRichText from './deserializeRichText'
import type { SerializedRichText } from './types'

export default function isEmpty(value: SerializedRichText): boolean {
  if (value.serialization_method !== 'slate_json_v1') {
    return value.content.length === 0
  }

  const elements = deserializeRichText(value)
  if (elements.length === 0) {
    return true
  }
  // Check for [{type: 'paragraph', children: {'text': ''}}]
  if (
    elements.length === 1 &&
    'type' in elements[0] &&
    elements[0].type === 'paragraph' &&
    elements[0].children.length === 1 &&
    'text' in elements[0].children[0] &&
    elements[0].children[0].text.length === 0
  ) {
    return true
  }
  return false
}
